<template>
  <el-dialog
    title="账单管理"
    :visible="visible"
    width="900px"
    top="100px"
    @close="handleClose"
    @opened="onOpened"
    class="modal"
  >
    <!-- 订单简要信息 -->
    <div style="margin-bottom: 15px; font-weight: bold;">
      订单号：{{ orderDetail ? orderDetail.orderNo : "" }} &nbsp;&nbsp;
      客户姓名：{{ orderDetail && orderDetail.member ? orderDetail.member.memberName : "" }} &nbsp;&nbsp;
      手机号：{{ orderDetail && orderDetail.member ? orderDetail.member.mobile : "" }}
    </div>

    <el-table :data="orderInfoTableData" border size="small" class="order-info">
      <el-table-column prop="leftBill" label="剩余待还账单" />
      <el-table-column prop="buyoutPrice" label="买断金" />
      <el-table-column prop="lockDate" label="待锁机日期" />
      <el-table-column prop="reserveAmount" label="挂账余额" />
    </el-table>

    <!-- 操作区域 -->
    <template v-if="!buyoutConfirm">
      <el-tabs v-model="activeTab" style="margin-top: 10px">
        <el-tab-pane label="延期/挂账" name="compensate">
          <el-form ref="compensateForm" :model="compensateForm" label-width="150px" style="margin-top: 10px">
            <el-form-item label="延期锁机日期" prop="lockDate">
              <el-date-picker
                v-model="compensateForm.lockDate"
                type="date"
                size="small"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                style="width: 200px"
                :picker-options="lockDatePickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="延期锁机服务费" prop="lockFee" :rules="lockFeeRules">
              <el-input
                v-model="compensateForm.lockFee"
                size="small"
                placeholder="请输入延期锁机服务费"
                style="width: 200px"
              ></el-input>
              <span style="margin-left: 8px; color: #909399">元</span>
            </el-form-item>
            <el-form-item label="新增挂账" prop="reserveAmount">
              <el-input
                v-model="compensateForm.reserveAmount"
                size="small"
                placeholder="请输入新增挂账"
                style="width: 200px"
              ></el-input>
              <span style="margin-left: 8px; color: #909399">元</span>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="线下还款" name="settlement">
          <el-form ref="settlementForm" :model="settlementForm" style="margin-top: 15px">
            <!-- 结清买断红色警告提示 -->
            <div v-if="settlementForm.settlePeriodNum === 99" class="buyout-warning">
              <i class="el-icon-warning buyout-warning__icon"></i>
              <div class="buyout-warning__text">
                <div class="buyout-warning__line buyout-warning__line--strong">当前操作将结清并买断订单，请谨慎核对</div>
                <div class="buyout-warning__line">结清后订单状态将变更为「已完成」，租期提前终止，不可撤销。</div>
              </div>
            </div>
            <el-form-item label="结清期数" prop="settlePeriodNum" :rules="[{ required: true, message: '请选择结清期数' }]">
              <el-select
                v-model="settlementForm.settlePeriodNum"
                size="small"
                placeholder="请选择结清期数"
                style="width: 200px"
              >
                <el-option
                  v-for="item in periodOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <!-- 计算表达式行 -->
              <div class="calc-row">
                <div class="calc-item">
                  <label class="calc-label"><span class="required-mark">*</span>现金支付</label>
                  <el-input
                    v-model="settlementForm.cashAmount"
                    size="small"
                    placeholder="请输入"
                    style="width: 150px"
                  ></el-input>
                </div>
                <span class="calc-symbol">+</span>
                <div class="calc-item">
                  <label class="calc-label">挂账抵扣</label>
                  <el-input
                    v-model="settlementForm.reserveAmount"
                    size="small"
                    placeholder="请输入"
                    style="width: 150px"
                  ></el-input>
                </div>
                <span class="calc-symbol">=</span>
                <div class="calc-item">
                  <label class="calc-label">实销金额</label>
                  <el-input
                    :value="actualSettleAmount"
                    size="small"
                    disabled
                    style="width: 150px"
                  ></el-input>
                </div>
              </div>

              <div class="balance-row">挂账余额：<span class="amount-result">¥{{ reserveBalanceText }}</span></div>

              <div class="btn-desc-row">
                <el-button type="success" size="small" @click="calcSettlement">计算</el-button>
                <span v-if="calcResult" class="calc-desc">
                  已选金额 <b class="amount-result">{{ calcResult.totalWaitPayAmount }}</b>
                </span>
                <span v-if="calcResult" class="calc-desc">
                  减免金额 <b class="amount-result">{{ calcResult.totalOffAmount }}</b>
                </span>
              </div>

              <!-- 挂账余额 > 0 但未填写挂账抵扣-->
              <div v-if="reserveTipVisible && !confirmedCashOnly" class="reserve-alert">
                <div class="reserve-alert__title">存在挂账余额¥{{ reserveBalanceText }}尚未抵扣</div>
                <div class="reserve-alert__desc">未填写「挂账抵扣」，将全额以现金支付。请确认是否继续。</div>
                <div class="tip-buttons">
                  <el-button type="primary" size="small" @click="payByCashOnly">仍以现金支付</el-button>
                </div>
              </div>

              <!-- 已确认以现金支付的绿色提示 -->
              <div v-if="greenTipVisible" class="cash-confirm-tip">
                <div class="cash-confirm-tip__title">已确认现金支付以及抵扣金额，可提交</div>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <div class="footer-buttons">
          <el-button @click="handleClose" size="small">取消</el-button>
          <el-button
            type="danger"
            :disabled="settlementSubmitDisabled"
            @click="handleSubmit"
            size="small"
          >提交</el-button>
        </div>
      </el-tabs>
    </template>

    <!-- 结清买断二次确认 -->
    <template v-else>
      <div class="confirm-step-row">
        <el-button size="small" icon="el-icon-arrow-left" @click="backToSettle">返回修改</el-button>
        <span class="confirm-step-label">二次确认</span>
      </div>
      <div class="buyout-confirm-info">
        <div class="buyout-confirm-info__title">请再次确认以下信息，提交后不可撤销</div>
        <div class="buyout-confirm-info__body">
          <div class="buyout-confirm-info__item">
            <span class="k">结清方式：</span><span class="v r">结清买断</span>
          </div>
          <div class="buyout-confirm-info__item">
            <span class="k">已选金额：</span><span class="v">¥{{ waitAmountText }}</span>
          </div>
          <div class="buyout-confirm-info__item">
            <span class="k">实销金额：</span><span class="v">¥{{ actualSettleAmount }}</span>
          </div>
          <div class="buyout-confirm-info__item">
            <span class="k">减免金额：</span><span class="v r">¥{{ offAmountText }}</span>
          </div>
        </div>
      </div>
    </template>

    <!-- 最近操作记录 -->
    <div class="record-title">动账记录</div>
    <el-table :data="recentActionList" border size="small">
      <el-table-column prop="actionName" label="变动类型" />
      <el-table-column prop="billName" label="账期类型" />
      <el-table-column prop="actionAmount" label="金额">
        <template slot-scope="{ row }">
          ￥ {{ row.actionAmount || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="actionTime" label="时间" />
      <el-table-column prop="actionUserName" label="操作人">
        <template slot-scope="{ row }">
          {{ row.actionUserName || '-' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 结清买断二次确认：勾选校验项 + 确认提交 -->
    <div v-if="buyoutConfirm" class="buyout-confirm-bottom">
      <div class="confirm-check-title">确认清单</div>
      <div class="confirm-check-list">
        <el-checkbox v-model="confirmAmountChecked" class="confirm-check">
          已核对已选金额（¥{{ waitAmountText }}）、实销金额（¥{{ actualSettleAmount }}）与减免金额（¥{{ offAmountText }}）
        </el-checkbox>
        <el-checkbox v-model="confirmPayChecked" class="confirm-check">
          已确认款项已到账，同意变更订单为「已完成」
        </el-checkbox>
      </div>
      <div class="footer-buttons">
        <el-button @click="handleClose" size="small">取消</el-button>
        <el-button
          type="danger"
          size="small"
          :disabled="!(confirmAmountChecked && confirmPayChecked)"
          @click="confirmSubmit"
        >确认提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getOrderInfoAPI,
  compensateBillAPI,
  calcSettlementAPI,
  submitSettlementAPI,
  getRecentActionListAPI,
} from "../api/bill-manage";

export default {
  name: "BillManage",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderNo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeTab: "compensate",
      orderDetail: null,
      compensateForm: {
        lockDate: "",
        lockFee: "",
        reserveAmount: "",
      },
      lockDatePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },
      settlementForm: {
        settlePeriodNum: null,
        cashAmount: "",
        reserveAmount: "",
      },
      calcResult: null,
      recentActionList: [],
      confirmedCashOnly: false,         //仅以现金支付
      buyoutConfirm: false,             // 是否处于二次确认步骤
      confirmAmountChecked: false,      // 已核对金额一致
      confirmPayChecked: false,         // 已确认款项到账并同意变更状态
    };
  },
  computed: {
    orderInfoTableData() {
      if (!this.orderDetail) return [];
      const d = this.orderDetail;
      return [{
        orderNo: d.orderNo,
        memberName: d.member ? d.member.memberName : "",
        mobile: d.member ? d.member.mobile : "",
        leftBill: `${d.leftBillPrice}（${d.leftBillNum}期）`,
        buyoutPrice: `¥${d.buyoutPrice || 0}`,
        lockDate: d.lockDate || "-",
        reserveAmount: `¥${d.reserveAmount || 0}`,
      }];
    },
    lockFeeRules() {
      if (this.compensateForm.lockDate) {
        return [
          { required: true, message: "选择了延期锁机日期时，延期锁机服务费必填" },
          {
            validator: (rule, value, callback) => {
              if (value !== "" && Number(value) < 0) {
                callback(new Error("延期锁机服务费最小为0"));
              } else {
                callback();
              }
            },
          },
        ];
      }
      return [];
    },
    actualSettleAmount() {
      const cash = Number(this.settlementForm.cashAmount) || 0;
      const reserve = Number(this.settlementForm.reserveAmount) || 0;
      return (cash + reserve).toFixed(2);
    },
    // 二次确认展示：已选金额
    waitAmountText() {
      return this.calcResult ? this.calcResult.totalWaitPayAmount : "0.00";
    },
    // 二次确认展示：减免金额
    offAmountText() {
      return this.calcResult ? this.calcResult.totalOffAmount : "0.00";
    },
    reserveBalance() {
      const d = this.orderDetail;
      return Number(d && d.reserveAmount) || 0;
    },
    reserveBalanceText() {
      return this.reserveBalance.toFixed(2);
    },
    // 已选择结清期数后，若挂账余额 > 0 但未填写挂账抵扣(空或0)时，提示抵扣
    reserveTipVisible() {
      const p = this.settlementForm.settlePeriodNum;
      const selected = p !== null && p !== undefined && p !== "";
      return selected && this.reserveBalance > 0 && !(Number(this.settlementForm.reserveAmount) > 0);
    },
    // 现金支付金额显示文本
    cashAmountText() {
      return (Number(this.settlementForm.cashAmount) || 0).toFixed(2);
    },
    // 挂账抵扣金额显示文本
    reserveAmountText() {
      return (Number(this.settlementForm.reserveAmount) || 0).toFixed(2);
    },
    // 线下还款：存在挂账且未抵扣、又未确认「仅现金支付」时，提交置灰
    settlementSubmitDisabled() {
      return (
        this.activeTab === "settlement" &&
        this.reserveTipVisible &&
        !this.confirmedCashOnly
      );
    },
    // 点过「仍以现金支付」后的绿色确认提示(抵扣仍为空时显示)
    greenTipVisible() {
      return this.confirmedCashOnly && this.reserveTipVisible;
    },
    periodOptions() {
      const options = [];
      if (this.orderDetail && this.orderDetail.leftBillNum) {
        for (let i = 1; i <= this.orderDetail.leftBillNum; i++) {
          options.push({
            label: `${i}期`,
            value: i,
          });
        }
      }
      options.push({ label: "结清买断", value: 99 });
      return options;
    },
  },
  watch: {
    // 切换结清期数时，清空该期数下已填的金额与计算结果
    "settlementForm.settlePeriodNum"(val) {
      if (val === null || val === undefined || val === "") return;
      this.settlementForm.cashAmount = "";
      this.settlementForm.reserveAmount = "";
      this.calcResult = null;
      this.confirmedCashOnly = false;
    },
    // 用户填写了挂账抵扣(>0)，撤回「仅现金支付」的确认
    "settlementForm.reserveAmount"(val) {
      if (Number(val) > 0) this.confirmedCashOnly = false;
    },
  },
  methods: {
    onOpened() {
      this.resetForms();
      this.$nextTick(() => {
        if (this.$refs.compensateForm) this.$refs.compensateForm.clearValidate();
        if (this.$refs.settlementForm) this.$refs.settlementForm.clearValidate();
      });
      if (this.orderNo) {
        this.fetchOrderInfo();
        this.fetchRecentActionList();
      }
    },
    async fetchOrderInfo() {
      this.orderDetail = await getOrderInfoAPI({ orderNo: this.orderNo });
    },
    async fetchRecentActionList() {
      this.recentActionList = await getRecentActionListAPI({ orderNo: this.orderNo }) || [];
    },
    resetForms() {
      this.compensateForm = {
        lockDate: "",
        lockFee: "",
        reserveAmount: "",
      };
      this.settlementForm = {
        settlePeriodNum: null,
        cashAmount: "",
        reserveAmount: "",
      };
      this.calcResult = null;
      this.activeTab = "compensate";
      this.recentActionList = [];
      this.confirmedCashOnly = false;
      this.buyoutConfirm = false;
      this.confirmAmountChecked = false;
      this.confirmPayChecked = false;
    },
    async submitCompensate() {
      await this.$refs.compensateForm.validate();
      const data = {
        orderNo: this.orderNo,
        lockDate: this.compensateForm.lockDate,
        lockFee: this.compensateForm.lockFee,
        reserveAmount: this.compensateForm.reserveAmount,
      };
      await compensateBillAPI(data);
      this.$message.success("操作成功");
      this.handleClose();
      this.$emit("success");
    },
    async calcSettlement() {
      await this.$refs.settlementForm.validate();
      const data = {
        orderNo: this.orderNo,
        settlePeriodNum: this.settlementForm.settlePeriodNum,
        cashAmount: this.settlementForm.cashAmount,
        reserveAmount: this.settlementForm.reserveAmount,
      };
      this.calcResult = await calcSettlementAPI(data);
    },
    async submitSettlement() {
      await this.$refs.settlementForm.validate();
      const data = {
        orderNo: this.orderNo,
        settlePeriodNum: this.settlementForm.settlePeriodNum,
        cashAmount: this.settlementForm.cashAmount,
        reserveAmount: this.settlementForm.reserveAmount,
      };
      await submitSettlementAPI(data);
      this.$message.success("结清提交成功");
      this.handleClose();
      this.$emit("success");
    },
    checkCashAmount() {
      const cash = this.settlementForm.cashAmount;
      if (cash === "" || cash === null || cash === undefined) {
        this.$message.error("请填写现金支付金额！");
        return false;
      }
      return true;
    },
    // 提示中「仍以现金支付」：确认不抵扣挂账，仅以现金支付
    payByCashOnly() {
      this.confirmedCashOnly = true;
    },
    handleSubmit() {
      if (this.activeTab === "compensate") {
        this.submitCompensate();
        return;
      }
      // 线下还款：现金支付金额必填
      if (!this.checkCashAmount()) return;
      // 结清买断(99)
      if (this.settlementForm.settlePeriodNum === 99) {
        this.confirmBuyout();
        return;
      }
      this.submitSettlement();
    },

    async confirmBuyout() {
      await this.calcSettlement();
      this.confirmAmountChecked = false;
      this.confirmPayChecked = false;
      this.buyoutConfirm = true;
    },
    // 返回修改
    backToSettle() {
      this.buyoutConfirm = false;
    },

    async confirmSubmit() {
      if (!this.checkCashAmount()) return;
      const data = {
        orderNo: this.orderNo,
        settlePeriodNum: this.settlementForm.settlePeriodNum,
        cashAmount: this.settlementForm.cashAmount,
        reserveAmount: this.settlementForm.reserveAmount,
      };
      await submitSettlementAPI(data);
      this.$message.success("结清提交成功");
      this.handleClose();
      this.$emit("success");
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.resetForms();
      this.orderDetail = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  /deep/ {
    .el-dialog__body {
      padding-top: 10px;
    }

    .el-form {
      margin-top: 0px!important;
    }

    .el-form-item {
      margin-bottom: 15px;
    }
  }
}

.order-info {
  margin-bottom: 10px;

  /deep/ th {
    font-weight: bold !important;
  }
}

.calc-row {
  display: flex;
  align-items: flex-end;
  gap: 14px;

  .calc-item {
    display: flex;
    flex-direction: column;

    .calc-label {
      color: #606266;
      white-space: nowrap;

      .required-mark {
        margin-right: 2px;
        color: #f56c6c;
      }
    }
  }

  .calc-symbol {
    font-size: 20px;
    color: #909399;
  }
}

.balance-row {
  margin-top: 10px;
  color: #606266;
}

.btn-desc-row {
  display: flex;
  align-items: center;
  gap: 16px;

  .calc-desc {
    color: #606266;
  }
}

.reserve-alert {
  margin-top: 12px;
  padding: 12px 16px;
  background-color: #E4F0FB;
  border-radius: 4px;
  color: #5CA4E8;
  font-size: 14px;

  .reserve-alert__title {
    font-weight: bold;
  }

  .reserve-alert__desc {
    margin-top: 4px;
    line-height: 1.6;
  }

  .tip-buttons {
    margin-top: 10px;
  }
}

.cash-confirm-tip {
  margin-top: 12px;
  padding: 12px 16px;
  background-color: #f0f9eb;
  border-radius: 4px;
  color: #67c23a;
  font-size: 14px;

  .cash-confirm-tip__title {
    font-weight: bold;
  }

  .cash-confirm-tip__desc {
    margin-top: 4px;
    line-height: 1.6;
  }
}

.buyout-warning {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 12px;
  padding: 10px 12px;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  color: #f56c6c;
  font-size: 14px;
  line-height: 2.2;

  .buyout-warning__icon {
    flex-shrink: 0;
    font-size: 16px;
    color: #f56c6c;
  }

  .buyout-warning__line--strong {
    font-weight: bold;
  }
}

.confirm-step-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 12px;

  .confirm-step-label {
    font-weight: 800;
    font-size: 14px;
  }
}

.buyout-confirm-info {
  padding: 12px 16px;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  font-size: 14px;

  .buyout-confirm-info__title {
    margin-bottom: 10px;
    color: #f56c6c;
    font-weight: bold;
  }

  .buyout-confirm-info__body {
    display: flex;
    flex-wrap: wrap;

    .buyout-confirm-info__item {
      margin-right: 32px;
      line-height: 1.8;

      .k {
        color: #606266;
      }

      .v {
        color: #303133;
        font-weight: 600;
      }

      .r {
        color: #f56c6c;
      }
    }
  }
}

.confirm-check-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.confirm-check-list {
  margin: 0 0 2px;

  .confirm-check {
    display: flex;
    align-items: center;
    margin-right: 0;
    line-height: 1.6;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}

.buyout-confirm-bottom {
  margin-top: 16px;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 0 0 12px 0;
  // margin: 0 0 16px;
  // border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.record-title {
  margin: 8px 0 10px;
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.amount-result {
    font-size: 16px;
    font-weight: bold;
    color: #f15f5f;
    white-space: nowrap;
  }
</style>
